export const loginRedirectUrl = '/login'
export const webAppUrl = process.env.REACT_APP_WEB_URL || ''
export const appUrl = process.env.REACT_APP_APP_URL
